import { render, staticRenderFns } from "./news-target-detail.vue?vue&type=template&id=3379891b&scoped=true&"
import script from "./news-target-detail.vue?vue&type=script&lang=js&"
export * from "./news-target-detail.vue?vue&type=script&lang=js&"
import style0 from "./news-target-detail.vue?vue&type=style&index=0&id=3379891b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3379891b",
  null
  
)

export default component.exports